var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64617 0.494343C1.84144 0.29908 2.15752 0.299578 2.35278 0.49484L5.49812 3.64018L8.64347 0.494841C8.83873 0.299579 9.15481 0.299081 9.35007 0.494344L10.5033 1.64761C10.6986 1.84288 10.6982 2.15903 10.5029 2.35429L7.35757 5.49963L10.5015 8.6436C10.6968 8.83887 10.6973 9.15498 10.502 9.35025L9.34879 10.5035C9.15353 10.6988 8.83738 10.6983 8.64212 10.5031L5.49812 7.35907L2.35413 10.5031C2.15887 10.6983 1.84272 10.6988 1.64746 10.5035L0.494212 9.35025C0.298942 9.15498 0.299439 8.83887 0.49471 8.6436L3.63868 5.49963L0.493343 2.35429C0.298081 2.15903 0.297648 1.84288 0.492909 1.64761L1.64617 0.494343Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.99ee0cc6fe581c15f8d3c463b37ead5a.svg";
export { ForwardRef as ReactComponent };